import { gql } from 'graphql-tag';

const AwardSuperSleuthMutation = gql`
  mutation awardSuperSleuth($id: ID!) {
    awardSuperSleuth(id: $id) {
      id
      sleuthName
      suspectName
      evidence
      isSuperSleuth
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const awardSuperSleuth = async ({ client, params }) => {
  const { id } = params;
  const result = await client.mutate({
    mutation: AwardSuperSleuthMutation,
    variables: { id },
  });

  return result.data;
};
